import React, { useEffect, useRef, useState } from 'react';
import { explanationObjectBreakdown } from '../utils/searchFunctions';
import { saveContent } from "../redux/slices/searchActions";
import { DateFormate, getBadge } from '../helpers/CommonHelpers';
import { useDispatch, useSelector } from 'react-redux';
import { getSavedContentIds } from '../redux/slices/searchActions';
import he from 'he';

export function Content({ hit, showScore }) {
  const dispatch = useDispatch();
  const contentItem = hit.source;
  const [isSaved, setIsSaved] = useState(false);
  const savedContentIds = useSelector((state) => state.search.getSavedContentIds);
  const [savedIds, setSavedIds] = useState(savedContentIds.post_ids);
  const [isLoading, setIsLoading] = useState(false);
  const [showExplain, setShowExplain] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);  
  const searchOptions = useSelector(state => state.search.searchOptions);
  const userData = window.IM_SEARCH_DATA || {};
  const isLoggedIn = userData.isLoggedIn;

  const handleScroll = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    document.addEventListener('mousedown', handleClickOutside);
    if(savedContentIds){
      displayCount(savedContentIds.post_ids?.length || 0);
    }
    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [savedContentIds.post_ids, isOpen]);

  useEffect(() => {
    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        setIsOpen(false)
      }
    });
  }, []);

  const fetchSavedContentIds = async () => {
    try {
      const userId = window.current_user_id || 2; // Default user ID for testing
      const response = await dispatch(getSavedContentIds({ userId }));
      const postIds = response.payload?.data?.post_ids || [];
      setSavedIds(postIds);
    } catch (error) {
      console.error('Error fetching saved content IDs:', error);
    }
  };

  // Update isSaved when savedIds or contentItem changes
  useEffect(() => {
    if(savedIds !== undefined){
      if (savedIds.includes(String(contentItem.id))) {
        setIsSaved(true);
      }
    }
  }, [savedIds, contentItem]);
  
  const displayCount = (total_results) => {
    // This function will update total saved item count in menu
    const fetchsavedlink = document.getElementById("saved-link");
    if (fetchsavedlink && total_results > 0) {
      const savedLink = document.getElementById("saved-link");
      if (savedLink) {
        savedLink.innerHTML = `
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0_15889_11" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="28" height="28">
            <rect width="28" height="28" fill="#D9D9D9"></rect>
          </mask>
          <g mask="url(#mask0_15889_11)">
            <path d="M6.41797 23.6276V6.19498C6.41797 5.60562 6.62214 5.10677 7.03047 4.69844C7.4388 4.2901 7.93765 4.08594 8.52701 4.08594H19.4756C20.065 4.08594 20.5638 4.2901 20.9721 4.69844C21.3805 5.10677 21.5846 5.60562 21.5846 6.19498V23.6276L14.0013 20.3744L6.41797 23.6276ZM8.16797 20.9443L14.0013 18.4359L19.8346 20.9443V6.19498C19.8346 6.10515 19.7972 6.0229 19.7223 5.94823C19.6477 5.87337 19.5654 5.83594 19.4756 5.83594H8.52701C8.43718 5.83594 8.35493 5.87337 8.28026 5.94823C8.2054 6.0229 8.16797 6.10515 8.16797 6.19498V20.9443Z" fill="#1C1B1F"></path>
          </g>
        </svg>
        <span class="saved-count">${total_results}</span>
      `;
      }      
    } else {
      const savedLink = document.getElementById("saved-link");
      if (savedLink) {
        savedLink.innerHTML = `
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0_15889_11" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="28" height="28">
            <rect width="28" height="28" fill="#D9D9D9"></rect>
          </mask>
          <g mask="url(#mask0_15889_11)">
            <path d="M6.41797 23.6276V6.19498C6.41797 5.60562 6.62214 5.10677 7.03047 4.69844C7.4388 4.2901 7.93765 4.08594 8.52701 4.08594H19.4756C20.065 4.08594 20.5638 4.2901 20.9721 4.69844C21.3805 5.10677 21.5846 5.60562 21.5846 6.19498V23.6276L14.0013 20.3744L6.41797 23.6276ZM8.16797 20.9443L14.0013 18.4359L19.8346 20.9443V6.19498C19.8346 6.10515 19.7972 6.0229 19.7223 5.94823C19.6477 5.87337 19.5654 5.83594 19.4756 5.83594H8.52701C8.43718 5.83594 8.35493 5.87337 8.28026 5.94823C8.2054 6.0229 8.16797 6.10515 8.16797 6.19498V20.9443Z" fill="#1C1B1F"></path>
          </g>
        </svg>
      `;
      }
    }
  };

  const toggleExplain = () => {
    setShowExplain(!showExplain);
  }

  const jsonStyle = {
    textAlign: 'left',
    backgroundColor: '#f4f4f4',
    padding: '10px',
    borderRadius: '4px',
    fontSize: '14px',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    tabSize: 2
  };

  let explanationObj = {};
  if (showScore && showScore === 'true') {
    explanationObj = explanationObjectBreakdown(hit.explanation);
  }
  
  const checkLastSignificantUpdate = () => {
      let lastSignificantUpdate = '';
      if(contentItem.lastSignificantUpdate){
        lastSignificantUpdate = `Updated: ${DateFormate(contentItem.lastSignificantUpdate, 'MMMM d, yyyy')}`;
      } else if(contentItem.publishDate){
        lastSignificantUpdate = DateFormate(contentItem.publishDate, 'MMMM d, yyyy')
      }

      return lastSignificantUpdate;
  }  
  
  const handleSave = () => {
    setIsLoading(true);
    const userID = window.current_user_id;
    const postId = contentItem.id; // Dynamically get the post ID
    const userId = userID ? userID : '2';
  
    if (userId && postId) {
      dispatch(saveContent({ userId, postId }))
        .then((res) => {
          if(res.payload.data){
            fetchSavedContentIds();
            if (res.payload.data.saved) {
              setIsSaved(true); // Mark as saved
            } else {
              setIsSaved(false); // Mark as unsaved
            }
          }
        })
        .catch(() => {
          console.log('An error occurred while saving the content.');
        })
        .finally(() => {
          setIsLoading(false); // Ensure loading state is reset
        });
    } else {
      console.log('User ID or Post ID is missing.');
      setIsLoading(false); // Reset loading state when IDs are missing
    }
  };
  
  return (
    <>
      <div className="resultsManagmentCardContent">
        
        <div className='report-bar-icons'>
          {!searchOptions?.isPublicSearch && (
            <div className='report-date-save' onClick={handleSave}>
            <span>{isSaved ? 'Saved' : 'Save'}</span>
              {isLoading ?
                <img alt="Loading" width="15" height="17" src="/wp-content/themes/dom/assets/img/loader.gif"></img>:
                <>
                  {!isSaved ?
                    <svg class="save" width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.417969 19.6276V2.19498C0.417969 1.60562 0.622135 1.10677 1.03047 0.698438C1.4388 0.290104 1.93765 0.0859375 2.52701 0.0859375H13.4756C14.065 0.0859375 14.5638 0.290104 14.9721 0.698438C15.3805 1.10677 15.5846 1.60562 15.5846 2.19498V19.6276L8.0013 16.3744L0.417969 19.6276ZM2.16797 16.9443L8.0013 14.4359L13.8346 16.9443V2.19498C13.8346 2.10515 13.7972 2.0229 13.7223 1.94823C13.6477 1.87337 13.5654 1.83594 13.4756 1.83594H2.52701C2.43718 1.83594 2.35493 1.87337 2.28026 1.94823C2.2054 2.0229 2.16797 2.10515 2.16797 2.19498V16.9443Z" fill="#757575" />
                    </svg> 
                  :
                    <svg class="saved" width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.417969 19.6276V2.19498C0.417969 1.60562 0.622135 1.10677 1.03047 0.698438C1.4388 0.290104 1.93765 0.0859375 2.52701 0.0859375H13.4756C14.065 0.0859375 14.5638 0.290104 14.9721 0.698438C15.3805 1.10677 15.5846 1.60562 15.5846 2.19498V19.6276L8.0013 16.3744L0.417969 19.6276Z" fill="#313131" />
                    </svg>
                  }
                </>
              }  
            </div>
          )}
          {searchOptions?.isPublicSearch && (!contentItem.accessRoles || contentItem.accessRoles.length === 0) && (
            <div className='report-date-save'>
              <span>Available to All</span>
            </div>
          )}
        </div>
        
        {contentItem.archived && (
          <span className="reportInfo archived-text">Archived</span>
        )}        
        {getBadge(contentItem.contentType, true)}
        {(checkLastSignificantUpdate() || (contentItem.authors && contentItem.authors.length > 0 && (contentItem?.lastSignificantUpdate || contentItem?.publishDate))) && (
            <span className="reportInfo">
              {checkLastSignificantUpdate()}
              {contentItem.authors && contentItem.authors.length > 0 && (
                <>
                  {(contentItem?.lastSignificantUpdate || contentItem?.publishDate) && <span className="dot"></span>}by&nbsp; 
                  {contentItem.authors.map((author, index) => (
                    <>
                      {author.title}{index < contentItem.authors.length - 1 ? ', ' : ''}
                    </>
                  ))}
                </>
              )}
            </span>
          )}

        <div className={contentItem.contentType === "infographics" && contentItem.thumbUrl ? "webinar-event-flex" : ""}>
          {contentItem.contentType === "infographics" && contentItem.thumbUrl && (
            <div className="webinar-image infographics-image-section" onClick={() => {
              window.location = `/${contentItem?.link ?? ''}`;
            }}>
              <img
                src={isLoggedIn ? contentItem.thumbUrl : contentItem.thumbBlurUrl}
                alt={""}           
                className="attachment-thumbnail-480 size-thumbnail-480"
              />
            </div>
          )}
          <div className="">
            <a href={`${contentItem?.link ?? '/'}`} className={`stretched-link reportTitle`}>{he.decode(contentItem?.title)}</a>
            <div className="">
              {contentItem?.shortDescription && (
                <div className="reportShortDesc" dangerouslySetInnerHTML={{ __html: contentItem.shortDescription }} />
              )}
            </div>
          </div>
        </div>
      </div>
      {showScore && showScore === 'true' && (
        <span className="testing" onClick={() => toggleExplain()} style={{ position: 'relative', cursor: 'pointer', zIndex: 1 }}>
          Match: {explanationObj.matchScore ?? 0}<br />
          {explanationObj && explanationObj.boostingQueryScore && (<>Boosting: {explanationObj.boostingQueryScore ?? 0} {"->"} {explanationObj.boostScore ?? 0} <br /></>)}
          Popularity and Recency: {explanationObj.popularityMultiplier ?? 0} {"->"} {explanationObj.score ?? 0}
        </span>
      )}
      {showExplain && (
        <div>
          <pre style={jsonStyle}>{explanationObj.explanation}</pre>
        </div>
      )}
    </>
  );
}